'use client';

import { c as _c } from "react/compiler-runtime";
import { MappedDesignProductItem } from '@/app/[abTest]/[locale]/(spreadshirt)/shop/design/utility/recommendations';
import { useImageBaseUrl } from '@/atoms/processEnvAtom';
import ProductSlider, { ProductSliderProps } from '@/components/ProductSlider/ProductSlider';
import { getCompositionImageAltText } from '@/utility/seo';
import { tracker } from '@/utility/tracking/tracker';
import { getSellableDetailHrefArgs } from '@/utility/urls';
type DesignSimiliarProductsProps = {
  compositionId: Composition['compositionId'];
  compositionName: string;
  mappedDesignProductItems: MappedDesignProductItem[];
  shopId: number;
  trackingDetail: `reco this-design-on-other-products ${string}`;
};
export const SimilarProductsSlider = t0 => {
  const $ = _c(20);
  const {
    compositionId,
    compositionName,
    mappedDesignProductItems,
    shopId,
    trackingDetail
  } = t0;
  const imageBaseUrl = useImageBaseUrl();
  let groupCheapestItems;
  if ($[0] !== mappedDesignProductItems) {
    groupCheapestItems = new Map();
    mappedDesignProductItems.forEach(item => {
      if (item.group) {
        const groupId = item.group.id;
        const currentCheapest = groupCheapestItems.get(groupId);
        if (!currentCheapest || item.price < currentCheapest.price) {
          groupCheapestItems.set(groupId, item);
        }
      }
    });
    $[0] = mappedDesignProductItems;
    $[1] = groupCheapestItems;
  } else {
    groupCheapestItems = $[1];
  }
  let t1;
  if ($[2] !== compositionId || $[3] !== compositionName || $[4] !== groupCheapestItems || $[5] !== imageBaseUrl || $[6] !== mappedDesignProductItems || $[7] !== shopId || $[8] !== trackingDetail) {
    let t2;
    if ($[10] !== groupCheapestItems) {
      t2 = item_0 => {
        if (item_0.group) {
          return groupCheapestItems.get(item_0.group.id) === item_0;
        } else {
          return true;
        }
      };
      $[10] = groupCheapestItems;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    const filteredDesignProductItems = mappedDesignProductItems.filter(t2);
    let t3;
    if ($[12] !== compositionId || $[13] !== compositionName || $[14] !== imageBaseUrl || $[15] !== shopId || $[16] !== trackingDetail) {
      t3 = (t4, index) => {
        const {
          sellable,
          productType,
          price,
          indexable,
          group
        } = t4;
        const title = group?.name || productType.name;
        const defaultAppearance = productType.appearances.find(appearance => appearance.id === String(sellable.defaultAppearanceId));
        return {
          title,
          productTypeId: productType.id,
          price,
          priceFormat: !!group ? "from" : "default",
          imageBaseUrl,
          favorite: {
            compositionId,
            sellableId: sellable.sellableId,
            productTypeId: productType.id,
            appearanceId: String(sellable.defaultAppearanceId),
            shopId,
            price,
            label: compositionName
          },
          link: {
            indexable,
            href: getSellableDetailHrefArgs({
              compositionId,
              sellableName: compositionName,
              productTypeName: productType.name,
              sellableId: sellable.sellableId
            }),
            onClick: (_, appearanceId) => {
              tracker.trackFeature({
                featureUsed: "product-card-click",
                detail: trackingDetail,
                product: {
                  productTypeId: productType.id,
                  appearanceId,
                  price,
                  amount: 1,
                  articleId: compositionId,
                  articleName: compositionName,
                  sellableId: sellable.sellableId,
                  position: index + 1
                }
              });
            }
          },
          images: [{
            type: "product",
            vpString: sellable.vpString,
            viewId: String(sellable.defaultViewId),
            appearanceId: String(sellable.defaultAppearanceId),
            alt: getCompositionImageAltText(compositionName, productType.name, defaultAppearance?.name ?? ""),
            title: `${compositionName}-${productType.name}`
          }],
          appearances: productType.appearances
        };
      };
      $[12] = compositionId;
      $[13] = compositionName;
      $[14] = imageBaseUrl;
      $[15] = shopId;
      $[16] = trackingDetail;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    t1 = filteredDesignProductItems.map(t3);
    $[2] = compositionId;
    $[3] = compositionName;
    $[4] = groupCheapestItems;
    $[5] = imageBaseUrl;
    $[6] = mappedDesignProductItems;
    $[7] = shopId;
    $[8] = trackingDetail;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const items = t1;
  let t2;
  if ($[18] !== items) {
    t2 = <ProductSlider items={items} optimizeImages={true} deferAppearances={true} deferBadges={true} />;
    $[18] = items;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  return t2;
};